import {
  InputLabel,
  MenuItem,
  Modal,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  compose,
  lifecycle,
  setPropTypes,
  withHandlers,
  withState
} from 'recompose';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import qs from 'query-string';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import MenuDrawerGroup from '../../components/MenuDrawerGroup';
import EditTextButton from '../../components/atoms/EditTextButton';
import DetailTextButton from '../../components/atoms/DetailTextButton';
import SearchButton from '../../components/atoms/SearchButton';
import ShopTableGroup from '../organisms/ShopTableGroup';
import GroupDetailGroup from '../organisms/GroupDetailGroup';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import GroupEditGroup from '../organisms/GroupEditGroup';
import { getGroups, getGroupDetail } from '../../actions/Groups';
import { getShops, downloadShop } from '../../actions/Shop';
import { getAccounts } from '../../actions/Accounts';
import {
  getBankList,
  getBankBranchList,
  GET_BANK_BRANCH_LIST_SUCCESS,
  GET_BANK_LIST_SUCCESS
} from '../../actions/Bank';
import { getTextBySystem as gts } from '../../utils';

const propTypes = {
  classes: PropTypes.object.isRequired
};

const drawerWidth = 240;

const styles = theme => ({
  root: {
    display: 'flex'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  menuButton: {
    marginRight: 36
  },
  hide: {
    display: 'none'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap'
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1
    }
  },
  toolbar: {
    display: 'flex',
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 15
  },
  paper: {
    padding: 20,
    marginBottom: 40,
    minWidth: 1024
  },
  groupName: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 15
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    width: 'calc(100% - 240px)',
    minWidth: 1024
  },
  tableRow: {
    border: '1px solid #CCCCCC'
  },
  tableCell: {
    borderBottom: '1px solid #CCCCCC'
  },
  tableHead: {
    fontWeight: 600
  },
  formLabel: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#000'
  },
  textField: {
    marginTop: 10
  },
  textInput: {
    height: 1
  },
  noPaddingCell: {
    padding: 0,
    border: 'none',
    paddingRight: 5,
    maxWidth: 200,
    minWidth: 200
  },
  buttonSearch: {
    margin: 0,
    height: 38
  },
  modal: {
    maxWidth: 978,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  select: {
    // width: 200,
    width: '100%',
    height: 38,
    marginTop: 10,
    display: 'flex',
    backgroundColor: '#FFF'
  },
  placeholder: {
    color: '#808080'
  },
  selectInput: {
    backgroundColor: '#FFF !important'
  }
});

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      shops: state.shops.shops,
      identityStatuses: state.identities.statuses,
      shopStatuses: state.shops.shopStatuses
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGroups,
          getGroupDetail,
          getShops,
          getAccounts,
          downloadShop,
          getBankList,
          getBankBranchList
        },
        dispatch
      )
    })
  ),
  // state => ({}),
  // dispatch => ({})
  setPropTypes(propTypes),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('groupId', 'setGroupId', 0),
  withState('groupName', 'setGroupName', ''),
  withState('address', 'setAddress', ''),
  withState('phone', 'setPhone', ''),
  withState('groupType', 'setGroupType', 'CHAIN_SHOP'),
  withState('groupTypeStr', 'setGroupTypeStr', 'チェーン店'),
  withState('page', 'setPage', 1),
  withState('city', 'setCity', ''),
  withState('prefectures', 'setPrefectures', ''),
  withState('building', 'setBuilding', ''),
  withState('idParam', 'setIdParam', ''),
  withState('shopNameParam', 'setShopNameParam', ''),
  withState('openStatusParam', 'setOpenStatusParam', ''),
  withState('addressParam', 'setAddressParam', ''),
  withState('filterParams', 'setFilterParams', {}),
  withState('groupDetail', 'setGroupDetail', {}),
  withState('openEditConfirm', 'updateOpenEditConfirm', false),
  withState('cityId', 'setCityId', ''),
  withState('resultMessage', 'setResultMessage', ''),
  withState('limit', 'setLimit', 15),
  withState('listBank', 'setListBank', []),
  withState('listBankBranch', 'setListBankBranch', []),
  withState('paymentGroupType', 'setPaymentGroupType', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangePage: props => async (page, filterParams) => {
      props.setPage(page);
      const shopSearchKey = {
        groupId: props.groupId,
        limit: props.limit,
        page,
        ...filterParams
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      // if (!props.targetGroupId) {
      const shopData = await props.actions.getShops(shopSearchKey);
      if (shopData.error === true && shopData.payload.status === 403) {
        sendLogin(props);
      }
      if (shopData.type !== 'GET_SHOPS_SUCCESS') {
        alert('失敗しました');
      }
      props.updateLoading(false);
      props.updateOpenProgress(false);
      // }
    },
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    openDetailModal,
    updateOpenDetailModal,
    openProgress,
    updateOpenProgress,
    openEditModal,
    updateOpenEditModal,
    loading,
    updateLoading,
    address,
    phone,
    groupTypeStr,
    setGroupTypeStr,
    groupName,
    city,
    prefectures,
    building,
    groupId,
    setGroupId,
    setGroupName,
    setAddress,
    setCity,
    setBuilding,
    setPrefectures,
    setPhone,
    checkSession,
    page,
    shopNameParam,
    setShopNameParam,
    openStatusParam,
    setOpenStatusParam,
    addressParam,
    setAddressParam,
    idParam,
    setIdParam,
    handleChangePage,
    setFilterParams,
    filterParams,
    groupDetail,
    setGroupDetail,
    openEditConfirm,
    updateOpenEditConfirm,
    cityId,
    setCityId,
    resultMessage,
    setResultMessage,
    account,
    limit,
    setLimit,
    history,
    listBank,
    setListBank,
    listBankBranch,
    setListBankBranch,
    paymentGroupType,
    setPaymentGroupType
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    const isDeveloper =
      typeof account !== 'undefined' && account.role === 'DEVELOPER';
    const isFukuoka =
      typeof account !== 'undefined' && account.fukuokaFlag === 1;
    const educateSystem =
      typeof account !== 'undefined' && account.educateSystem;
    const groupDisplayLimit =
      isGroup &&
      (account.groupType === 'CAMPAIGN' ||
        account.groupType === 'OTHERS' ||
        account.groupType === 'GOCHI_KID');
    const gochiKidShopApplyType =
      typeof account !== 'undefined' && account.gochiKidShopApplyType;
    const roles = {
      isShop,
      isGroup,
      isSecretariat,
      isDeveloper
    };

    const progress = {
      loading,
      updateLoading,
      openProgress,
      updateOpenProgress,
      resultMessage,
      setResultMessage
    };

    const handleSearch = () => {
      const newFilterParams = {
        shopId: idParam || undefined,
        shopName: shopNameParam || undefined,
        shopStatus: openStatusParam || undefined,
        address: addressParam || undefined
      };
      setFilterParams(newFilterParams);
      handleChangePage(1, newFilterParams);
    };

    const downloadCsvBlob = (blob, fileName) => {
      if (window.navigator.msSaveOrOpenBlob) {
        // for IE,Edge
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        // for chrome, firefox
        const url = URL.createObjectURL(new Blob([blob], { type: 'text/csv' }));
        const linkEl = document.createElement('a');
        linkEl.href = url;
        linkEl.setAttribute('download', fileName);
        document.body.appendChild(linkEl);
        linkEl.click();
        linkEl.parentNode.removeChild(linkEl);
        // iOSのクリックイベント対策
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 1000);
      }
    };

    const csvDownloadAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const response = await actions
        .downloadShop(filterParams)
        .then(data => checkSession(data));
      if (response.type === 'DOWNLOAD_SHOP_SUCCESS') {
        const timeStamp = moment()
          .tz('Asia/Tokyo')
          .format('YYYYMMDDHHmm');
        updateOpenProgress(false);
        setResultMessage('');
        updateLoading(false);
        let csvName = `${timeStamp}_shop_info.csv`;
        if (typeof account !== 'undefined' && account.fukuokaFlag === 1) {
          csvName = `${timeStamp}_kyoshitsu_info.csv`;
        }
        downloadCsvBlob(response.payload, csvName);
      } else {
        setResultMessage('店舗情報ダウンロードに失敗しました。');
        updateLoading(false);
      }
    };

    const detailOpenAction = () => {
      updateLoading(true);
      updateOpenProgress(true);
      // getGochiMenu(params.id)
      //   .then(() => {
      //     progress.updateOpenProgress(false);
      //     progress.updateLoading(false);
      //     updateOpenDetailModal(true);
      //   })
      //   .catch(error => {
      //     progress.updateOpenProgress(false);
      //     progress.updateLoading(false);
      //     console.log(error);
      //   });
      updateOpenDetailModal(true);
      updateLoading(false);
      updateOpenProgress(false);
    };

    const editOpenAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const bankResponse = await actions
        .getBankList()
        .then(data => checkSession(data));
      if (bankResponse.type === GET_BANK_LIST_SUCCESS) {
        setListBank(bankResponse.payload);
      } else {
        setListBank([]);
      }
      const bankBranchResponse = await actions
        .getBankBranchList()
        .then(data => checkSession(data));
      if (bankBranchResponse.type === GET_BANK_BRANCH_LIST_SUCCESS) {
        setListBankBranch(bankBranchResponse.payload);
      } else {
        setListBankBranch([]);
      }
      // getGochiMenu(params.id)
      //   .then(() => {
      //     progress.updateOpenProgress(false);
      //     progress.updateLoading(false);
      //     updateOpenDetailModal(true);
      //   })
      //   .catch(error => {
      //     progress.updateOpenProgress(false);
      //     progress.updateLoading(false);
      //     console.log(error);
      //   });
      updateOpenEditModal(true);
      updateLoading(false);
      updateOpenProgress(false);
    };

    const getDetail = () => {
      const url = window.location.search;
      const { shopId } = qs.parse(url);
      setIdParam(shopId);
      isAuthenticated({ history });
      updateOpenProgress(true);
      updateLoading(true);
      actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        checkSession(data);
        if (data.payload.role === 'SECRETARIAT') {
          await actions.getGroups();
          updateOpenProgress(false);
          updateLoading(false);
          return;
        }
        await actions.getGroupDetail(data.payload.groupId).then(groupData => {
          setGroupDetail(groupData.payload);
          setGroupId(groupData.payload.groupId);
          setGroupName(groupData.payload.groupName);
          setPhone(groupData.payload.phone);
          setAddress(groupData.payload.address);
          setCity(groupData.payload.city);
          setCityId(groupData.payload.cityId);
          setPrefectures(groupData.payload.prefectures);
          setBuilding(groupData.payload.building);
          setGroupTypeStr(groupData.payload.groupTypeStr);
          setPaymentGroupType(groupData.payload.paymentGroupType);
          actions
            .getShops({
              page,
              limit,
              shopId
            })
            .then(shopData => {
              checkSession(shopData);
              if (shopData.type === 'GET_SHOPS_SUCCESS') {
                // this.props.updateOpenTable(true);
              }
              updateOpenProgress(false);
              updateLoading(false);
            });
        });
      });
    };

    useEffect(() => {
      getDetail();
    }, []);

    return (
      <div className={classes.root}>
        <MenuDrawerGroup title="グループ店舗一覧" />
        <main className={classes.content}>
          <div className={classes.toolbar}>
            {isFukuoka ? 'グループ教室一覧' : 'グループ店舗一覧'}
          </div>
          <Paper className={classes.paper}>
            <div className={classes.groupName}>{groupName}</div>
            <Table>
              <TableHead className={classes.tableHead}>
                <TableRow className={classes.tableRow}>
                  <TableCell className={classes.tableCell}>住所</TableCell>
                  <TableCell className={classes.tableCell}>
                    {isFukuoka ? '代表電話番号' : '電話番号 '}
                  </TableCell>
                  {!isFukuoka && (
                    <TableCell className={classes.tableCell}>
                      グループ種別
                    </TableCell>
                  )}
                  <TableCell className={classes.tableCell} />
                  <TableCell className={classes.tableCell} />
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow className={classes.tableRow}>
                  <TableCell className={classes.tableCell}>
                    {prefectures + city + address + building}
                  </TableCell>
                  <TableCell className={classes.tableCell}>{phone}</TableCell>
                  {!isFukuoka && (
                    <TableCell className={classes.tableCell}>
                      {groupTypeStr}
                    </TableCell>
                  )}
                  <TableCell className={classes.tableCell}>
                    <DetailTextButton onClickAction={detailOpenAction} />
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    <EditTextButton onClickAction={editOpenAction} />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Paper>

          <Paper className={classes.paper}>
            <TableRow>
              <TableCell size="small" className={classes.noPaddingCell}>
                <InputLabel className={classes.formLabel}>
                  {isFukuoka ? '教室ID' : '店舗ID'}
                </InputLabel>
                <TextField
                  placeholder="例) 0123"
                  variant="outlined"
                  value={idParam}
                  onChange={e => setIdParam(e.target.value)}
                  className={classes.textField}
                  inputProps={{ className: classes.textInput }}
                />
              </TableCell>

              <TableCell size="small" className={classes.noPaddingCell}>
                <InputLabel className={classes.formLabel}>
                  {isFukuoka ? '教室名' : '店舗名'}
                </InputLabel>
                <TextField
                  placeholder={isFukuoka ? '例 Gigi〇〇校' : '例) Gigi 〇〇店'}
                  variant="outlined"
                  value={shopNameParam}
                  onChange={e => setShopNameParam(e.target.value)}
                  className={classes.textField}
                  inputProps={{ className: classes.textInput }}
                />
              </TableCell>

              <TableCell size="small" className={classes.noPaddingCell}>
                <InputLabel className={classes.formLabel}>
                  {isFukuoka ? 'ステータス' : '開店状況'}
                </InputLabel>
                <Select
                  variant="outlined"
                  className={classes.select}
                  // classes={{ focused: classes.select }}
                  inputProps={{
                    className: classes.selectInput
                    // classes: { focused: classes.selectInput }
                  }}
                  value={openStatusParam}
                  onChange={e => setOpenStatusParam(e.target.value)}
                  displayEmpty
                >
                  <MenuItem value="">選択なし</MenuItem>
                  <MenuItem value="AVAILABLE">利用可能</MenuItem>
                  <MenuItem value="PRE_AVAILABLE">
                    {isFukuoka ? '休止中' : '準備中'}
                  </MenuItem>
                  {!isFukuoka && <MenuItem value="UNREGISTER">未登録</MenuItem>}
                  {!isFukuoka && (
                    <MenuItem value="SUSPENDED">利用停止中</MenuItem>
                  )}
                  <MenuItem value="CLOSED">
                    {isFukuoka ? '抹消・取消' : '閉店'}
                  </MenuItem>
                </Select>
              </TableCell>

              <TableCell size="small" className={classes.noPaddingCell}>
                <InputLabel className={classes.formLabel}>住所</InputLabel>
                <TextField
                  placeholder={gts('例) 東京都 渋谷区 0-0-0', educateSystem)}
                  variant="outlined"
                  className={classes.textField}
                  value={addressParam}
                  onChange={e => setAddressParam(e.target.value)}
                  inputProps={{ className: classes.textInput }}
                />
              </TableCell>

              <TableCell
                size="small"
                className={classes.noPaddingCell}
                style={{ verticalAlign: 'bottom' }}
              >
                <SearchButton
                  customStyles={classes.buttonSearch}
                  onClickAction={() => handleSearch()}
                />
              </TableCell>
            </TableRow>
          </Paper>

          <ShopTableGroup
            filterParams={filterParams}
            onChangePage={p => handleChangePage(p, filterParams)}
            page={page}
            handleChangePage={handleChangePage}
            progress={progress}
            roles={roles}
            limit={limit}
            setLimit={setLimit}
            csvDownloadAction={csvDownloadAction}
            groupId={groupId}
            setGroupId={setGroupId}
            handleSearch={handleSearch}
            isFukuoka={isFukuoka}
            groupDisplayLimit={groupDisplayLimit}
            groupPaymentGroupType={paymentGroupType}
            educateSystem={educateSystem}
            gochiKidShopApplyType={gochiKidShopApplyType}
          />
        </main>
        <Modal
          open={openDetailModal}
          onClose={() => {
            updateOpenDetailModal(false);
          }}
          className={classes.modal}
        >
          <GroupDetailGroup
            updateOpenDetailModal={updateOpenDetailModal}
            detail={groupDetail}
            isFukuoka={isFukuoka}
          />
        </Modal>

        <Modal
          open={openEditModal}
          onClose={() => {
            updateOpenEditModal(false);
          }}
          className={classes.modal}
        >
          <GroupEditGroup
            updateOpenEditModal={updateOpenEditModal}
            openEditConfirm={openEditConfirm}
            updateOpenEditConfirm={updateOpenEditConfirm}
            editInput={groupDetail}
            setDisplayGroupName={setGroupName}
            cityId={cityId}
            setCityId={setCityId}
            onEditSuccess={getDetail}
            isFukuoka={isFukuoka}
            listBank={listBank}
            listBankBranch={listBankBranch}
          />
        </Modal>

        <ProgressDialog openProgress={openProgress} loading={loading} />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
